import BaseButton from './BaseButton';

const SaveButton = ({ type = 'submit', color = 'primary', text = 'Salva', onClick, className, style, size }) => (
  <BaseButton type={type} color={color} onClick={onClick} className={className} style={style} size={size}>
    <i className="fa fa-save" /> {text}
  </BaseButton>
);

export default SaveButton;
